<div class="bgAdColor">
    <div class="text-truncate headAd1">
        <mat-icon style="position: relative; top: 5px">stars</mat-icon>
        {{message}}
    </div>
    <div class="text-truncate headAd2">
        Choose from a range of pre-built scenes. Get up and running in no time...
    </div>
</div>
